import React, {useState, useEffect } from 'react'

import { Accordion} from 'react-bootstrap';
import { phone_format } from "./../../components/Utils";
import ShowMessages from '../Exceptions';
import loadingButton  from '../../pages/layouts/Buttons'
import api from '../../services/api';
import Loading from '../Loading';
import { ReadDataStorage, IDCOMPANY } from '../../services/auth'
import USER from './../../assets/user-gray.png'
import WHATSAPP from './../../assets/whatsapp.png'

const AddParticipants = ({data}) => {
    const [loading, setLoading]                   = useState(false)
    const [dataUser, setDataUser]                 = useState([])
    const [dataLead, setDataLead]                 = useState([])
    const [dataSelection, setDataSelection]       = useState([])

    const handleSubmit = async(event) => {
        loadingButton(true,document.querySelector('#submit-participants'),document.querySelector('#submit-participants').children[0].classList,document.querySelector('#submit-participants').lastChild.nodeValue)
        event.preventDefault()

        try {                        
            await api.post('/addparticipants',{dataSelection,
                                               idmessagehistoryheader : data.idmessagehistoryheader })
                     .then((response) => {
                        data.handleClose()
       
                     })
                    .catch((error) => {
                        ShowMessages(error)
                        loadingButton(false,document.querySelector('#submit-participants'))
                    })  
        } catch (response) {
            loadingButton(false,document.querySelector('#submit-participants'))
            ShowMessages(response)
        }
    }

    const addParticipant = (_item) => {
        if (dataSelection.length >= 3) {
            ShowMessages({status : 500, message : 'Número máximo de 3 participantes foi atingido!'})
            return
        }

        const _participant = {
            type     : (_item?.idpeople || 0) > 0 ? 1 : 0, // 0 usuario - 1 numero externo
            number   : _item?.phone,
            iduser   : _item?.iduser,
            name     : _item?.name,
            idpeople : _item?.idpeople,
            row      : _item 
        }

        if (_participant.type === 0) {
            const _user = dataUser.filter(_item => _item.iduser !== _participant.iduser)
            setDataUser(_user)
        } else {
            const _lead = dataLead.filter(_item => _item.idpeople !== _participant.idpeople)
            setDataLead(_lead)
        }
        setDataSelection(dataSelection => dataSelection.concat(_participant))
    }

    const removeParticipant = (_item) => {
        if (_item.type === 0) {
            setDataUser(dataUser => dataUser.concat(_item.row))
            const _dataSelection = dataSelection.filter(_filter => _item.iduser !== _filter.iduser)
            setDataSelection(_dataSelection)
        } else {
            setDataLead(dataLead => dataLead.concat(_item.row))
            const _dataSelection = dataSelection.filter(_filter => _item.idpeople !== _filter.idpeople)
            setDataSelection(_dataSelection)
        }
    }

    useEffect(() => {
        const getData = async () => {
            setLoading(true) // Inicia o loading antes de iniciar as requisições
    
            try {
                const [users,clients] = await Promise.all([
                    api.post('/showUserCompany', { idcompany: ReadDataStorage(IDCOMPANY)}),
                    api.get("/getClient")
                ]);
                setDataUser(users.data)
                setDataLead(clients.data)
    
            } catch (error) {
                ShowMessages(error);
            } finally {
                setLoading(false); // Finaliza o loading quando ambas as requisições terminarem
            }
        };
    
        getData();
    }, []);
    

    return (
        <aside className="sidebar" style={{ padding: "10px", gap: "5px", display: "flex", flexDirection: "column", overflow: "hidden", width: "330px" }}>
            {loading ? (
                <Loading loading={loading}/>
            ) : (
                    <>
                        <div style={{display:"flex", gap:"8px", flexDirection:"column"}}>
                            {(dataSelection && dataSelection.length > 0) && (
                                <div>
                                    <button type="button" className='btn btn-success' onClick={e => handleSubmit()} id="submit-participants">
                                        <i className='fa fa-user-plus'/>
                                        <span> Adicionar Usuários Selecionados</span>
                                    </button>
                                </div>
                            )}
                            <div >
                                {(dataSelection && dataSelection.length > 0) && (
                                    <div className='bg bg-primary' style={{padding:"5px"}}>
                                        <span>Participantes Adicionados</span>
                                    </div>
                                )}
                                <div style={{maxHeight:"230px", overflow:"auto"}}>
                                    <div style={{width:"100%", gap: "5px", display:"flex", flexDirection:"column"}}>
                                                    {dataSelection && dataSelection.map(_item => {
                                                        return (
                                                            <div className="box-shadow box-participant " style={{ display: "flex", gap: "10px"}}>
                                                                <div>
                                                                    <div>
                                                                        <img style={{ width: "50px", height: "50px", borderRadius: "50%" }} onError={(e) => { e.target.src = USER }} src={_item.pathphoto || USER} alt="" />
                                                                    </div>
                                                                    <div style={{ marginTop: "-20px", marginLeft: "30px" }}>
                                                                        <img alt="" style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={WHATSAPP}></img>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "10px" }}>
                                                                    <div style={{ width: "100%" }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                                                            <span style={{ fontWeight: "bold" }}>{_item?.name}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div>
                                                                    <button type="button" style={{background:"transparent", border:"0px"}} onClick={e => removeParticipant(_item)}>
                                                                        <i className='fa fa-trash'/>
                                                                    </button>
                                                                    
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                    </div> 
                                </div>
                            </div>
                            <div className='bg bg-warning' style={{padding:"5px", borderRadius:"5px",display:"flex", gap:"5px", alignItems:"center"}}> 
                                <i className='fa fa-triangle-exclamation' style={{color:"#272829", fontSize:"28px"}}/>
                                <span style={{color:"#272829"}}>Escolha os usuários dentre as categorias e clique para adicionar.</span>
                            </div>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header className="own-acordion">
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            <i className='fa fa-users' />
                                            <span className="w-100">Usuários do Sistema</span>
                                        </div>
                                    </Accordion.Header>
                                    <Accordion.Body className="p-0" style={{ height: "250px", overflow: "auto" }}>
                                        <div style={{ display: "flex", gap: "5px", padding: "10px" }}>
                                            <div style={{width:"100%", gap: "5px", display:"flex", flexDirection:"column"}}>
                                                    {dataUser && dataUser.map(_item => {
                                                        return (
                                                            <div className="box-shadow box-participant " style={{ display: "flex", gap: "10px"}} onClick={e => addParticipant(_item)}>
                                                                <div>
                                                                    <div>
                                                                        <img style={{ width: "50px", height: "50px", borderRadius: "50%" }} onError={(e) => { e.target.src = USER }} src={_item?.pathphoto || USER} alt="" />
                                                                    </div>
                                                                    <div style={{ marginTop: "-20px", marginLeft: "30px" }}>
                                                                        <img alt="" style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={WHATSAPP}></img>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "10px" }}>
                                                                    <div style={{ width: "100%" }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                                                            <span style={{ fontWeight: "bold" }}>{_item?.name}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                            </div>    
                                        </div>
                                        
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1" style={{ marginTop: "5px" }}>
                                    <Accordion.Header className="own-acordion">
                                        <div style={{ display: "flex", gap: "5px" }}>
                                            <i className='fa fa-users-line' />
                                            <span className="w-100">Agenda</span>
                                        </div>

                                    </Accordion.Header>
                                    <Accordion.Body className="p-0" style={{ height: "250px", overflow: "auto" }}>
                                        <div style={{ display: "flex", gap: "5px", padding: "10px" }}>
                                            <div style={{width:"100%", gap: "5px", display:"flex", flexDirection:"column"}}>
                                                    {dataLead && dataLead.map(_item => {
                                                        return (
                                                            <div className="box-shadow box-participant " style={{ display: "flex", gap: "10px"}} onClick={e => addParticipant(_item)}>
                                                                <div>
                                                                    <div>
                                                                        <img style={{ width: "50px", height: "50px", borderRadius: "50%" }} onError={(e) => { e.target.src = USER }} src={_item.pathphoto || USER} alt="" />
                                                                    </div>
                                                                    <div style={{ marginTop: "-20px", marginLeft: "30px" }}>
                                                                        <img alt="" style={{ width: "20px", height: "20px", borderRadius: "50%" }} src={WHATSAPP}></img>
                                                                    </div>
                                                                </div>
                                                                <div style={{ display: "flex", justifyContent: "space-between", width: "100%", marginTop: "10px" }}>
                                                                    <div style={{ width: "100%" }}>
                                                                        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                                                            <span style={{ fontWeight: "bold" }}>{_item?.name}</span>
                                                                            <span style={{ fontWeight: "bold" }}>{phone_format(_item?.phone)}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })}
                                            </div>    
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </>
               )}
        </aside>
         
    )
};

export default AddParticipants;
